<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Stream Keyword Guide</h3>
      </div>
    </div>
  </div>
</div>

<dl class="row">
  <dt class="col-12"><h4>Customized URL</h4></dt>
  <dd class="col-12">
    <table class="table table-striped table-bordered mt-3 text-center" style="width:100%">
      <thead>
        <tr>
          <th>Title</th>
          <th>Content</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>&#123;macroName&#125;</td>
          <td class="text-left">
            普通的宏定义，最终值为参数名为macroName的值
          </td>
        </tr>
        <tr>
          <td>&#123;macroName:skipNum&#125;</td>
          <td class="text-left">
            先获取参数名为macroName的值，然后忽略前skipNum字符，即为最终值; skipNum为正整数
          </td>
        </tr>
        <tr>
          <td>Example</td>
          <td class="text-left">
            <span class="font-italic text-danger">Assume Data:</span><br>
            <ol>
              <li>CustomizedURL is http://google.com?click_id=<span class="text-info">&#123;clickId&#125;</span>&click_id_sub=<span class="text-info">&#123;clickId<span class="text-danger font-weight-bold">:1</span>&#125;</span></li>
              <li>接收到的参数名称为：<span class="text-info">clickId</span>, 参数值为：<span class="text-danger">a</span><span class="text-warning">bcdefghijk</span></li>
            </ol>
            <span class="font-italic text-danger">Real Postback URL:</span><br>
            http://google.com?click_id=<span class="text-danger">a</span><span class="text-warning">bcdefghijk</span>&click_id_sub=<span class="text-warning">bcdefghijk</span>
          </td>
        </tr>
      </tbody>
    </table>
  </dd>

  <dt class="col-12"><h4>Pay365 Keyword</h4></dt>
  <dd class="col-12">
    <table class="table table-striped table-bordered mt-3 text-center" style="width:100%">
      <thead>
        <tr>
          <th>Title</th>
          <th>Content</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Keyword Receiving URL</td>
          <td class="text-left">
            http://pays2s.intelligent-earnings.com/stream/pay365<span class="text-info">[/SUR]</span>
          </td>
        </tr>
        <tr>
          <td>Affiliate Receiving URL</td>
          <td class="text-left">
            http://pays2s.intelligent-earnings.com/aff-stream/pay365/(<span class="text-primary">affiliate</span>)<span class="text-info">[/SUR]</span>
          </td>
        </tr>
        <tr>
          <td>forward-types</td>
          <td class="text-left">
            Define which types can be forwarded to client; <br>
            Case Insensitive<br>
            <span class="font-weight-bold font-italic text-danger">S:</span> Subscribe Action;
            <span class="font-weight-bold font-italic text-danger">U:</span> Unsubscribe Action;
            <span class="font-weight-bold font-italic text-danger">R:</span> Renewal Action;
          </td>
        </tr>
        <tr>
          <td>Keyword Example</td>
          <td class="text-left">
            <span class="font-weight-bold font-italic text-info">Only Sub Log:</span> http://pays2s.intelligent-earnings.com/stream/pay365<br>
            <span class="font-weight-bold font-italic text-info">Only Sub Log:</span> http://pays2s.intelligent-earnings.com/stream/pay365/S<br>
            <span class="font-weight-bold font-italic text-info">Sub&Unsub Log:</span> http://pays2s.intelligent-earnings.com/stream/pay365/SU<br>
            <span class="font-weight-bold font-italic text-info">Sub&Unsub&Renewal Log:</span> http://pays2s.intelligent-earnings.com/stream/pay365/SUR<br>
          </td>
        </tr>
        <tr>
          <td>Affiliate Example</td>
          <td class="text-left">
            <span class="font-italic text-danger">Assume Data:</span><br>
            <ol>
              <li>SC: 32232, KW: F1, Affiliate: A</li>
            </ol>
            <span class="font-italic text-danger">Result:</span><br>
            <ol>
              <li>Received URL: http://pays2s.intelligent-earnings.com/aff-stream/pay365/<span class="text-info">A</span><span class="text-primary">[/SUR]</span></li>
              <li>
                配置回传keyword时，keyword值应为F1@A
              </li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>Click ID Macro</td>
          <td class="text-left">&#123;clickId&#125;</td>
        </tr>
        <tr>
          <td>去掉首位affiliate标识的Click ID Macro</td>
          <td class="text-left">&#123;clickId:1&#125;</td>
        </tr>
      </tbody>
    </table>
  </dd>
</dl>
